import { getContentAsText, isAttachmentContent, MessageContextMap, } from "@shared";
import { writable } from "../utils/stores";
import { notEq } from "./utils";
export class DraftMessage {
    textContent;
    attachment;
    editingEvent;
    replyingTo;
}
export function createDraftMessagesStore() {
    const store = writable(new MessageContextMap(), undefined, notEq);
    function updateDraft(key, fn) {
        store.update((s) => {
            let draft = s.get(key);
            if (draft === undefined) {
                draft = new DraftMessage();
            }
            s.set(key, fn(draft));
            return s;
        });
    }
    return {
        subscribe: (sub, invalidate) => store.subscribe(sub, invalidate),
        get value() {
            return store.value;
        },
        setTextContent(key, textContent) {
            updateDraft(key, (d) => ({ ...d, textContent }));
        },
        setAttachment(key, attachment) {
            updateDraft(key, (d) => ({ ...d, attachment }));
        },
        setReplyingTo(key, replyingTo) {
            updateDraft(key, (d) => ({ ...d, replyingTo }));
        },
        delete(key) {
            store.update((map) => {
                map.delete(key);
                return map;
            });
        },
        setEditing(key, editingEvent, userLookup) {
            updateDraft(key, (d) => {
                return {
                    ...d,
                    textContent: getContentAsText(editingEvent.event.content),
                    editingEvent: editingEvent,
                    attachment: isAttachmentContent(editingEvent.event.content)
                        ? editingEvent.event.content
                        : undefined,
                    replyingTo: editingEvent.event.repliesTo &&
                        editingEvent.event.repliesTo.kind === "rehydrated_reply_context"
                        ? {
                            ...editingEvent.event.repliesTo,
                            content: editingEvent.event.content,
                            sender: userLookup.get(editingEvent.event.sender),
                        }
                        : undefined,
                };
            });
        },
    };
}
